<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "商标分解" : "商标分解" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='550'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-card v-for="(item, idx) in form.trademarks" :key="idx" class="mb-3" outlined>
              <v-card-title>商标NO.{{idx+1}}</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <file-upload
                      label="Logo上传"
                      :rules="required"
                      outlined
                      prepend-icon=''
                      accept=".jpg,.png,.jpeg"
                      :bucket='bucket'
                      @on-file='onFileName($event, idx)'
                      :lazy='false'
                      hide-details="auto"
                    />
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" md="12">
                    <v-text-field
                        hide-details="auto"
                        :key='idx'
                        label="申请人"
                        outlined
                        v-model="form.trademarks[idx].applyName">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                        hide-details="auto"
                        outlined
                        v-model="form.trademarks[idx].typeId"
                        :rules="required"
                        :items="trademarkTypeItems"
                        item-text="name"
                        item-value="id"
                        label="商标类型"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      hide-details="auto"
                      outlined
                      v-model="form.trademarks[idx].projectTypeIdList"
                      :rules="array"
                      :items="projectTypeItems"
                      label="商标类别(待定选0)"
                      multiple
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      hide-details="auto"
                      outlined
                      v-model="form.trademarks[idx].agencyId"
                      :rules="required"
                      :items="trademarkAgencyItems"
                      item-text="name"
                      item-value="id"
                      label="代理机构"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                    :items="agenters"
                    :rules="required"
                    item-text="label"
                    item-value="value"
                    label="专利代理人"
                    outlined
                    v-model="form.trademarks[idx].agenter"
                    hide-details
                  ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { isEmpty } from '@/utils/stringUtil.js'
  import { decp } from '@/api/copyright/trademark.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import FileUpload from '@/components/oss/Index.vue'

  export default {
    name: 'TrademarkDecpEdit',
    components: {
      FileUpload
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        agenters: [
          { label: '王文利', value: '王文利' }
        ],
        bucket: 'yd-trademark',
        trademarkTypeItems: [],
        trademarkAgencyItems: [],
        form: {
          orderId: '',
          contractId: '',
          customerId: '',
          trademarks: [
            {
              name: '',
              applyName: '',
              agencyId: 498,
              typeId: '',
              agenter: '王文利',
              projectTypeIdList: [],
              logoFile: ''
            }
          ]
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          decp(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      traNumberInput (val) {
        this.form.trademarks = []
        for (let i = 0; i < Number(val); i++) {
          this.form.trademarks.push(
            {
              name: '',
              logoFile: '',
              applyName: this.item.data.customer.name,
              agenter: '王文利',
              typeId: '',
              agencyId: 498,
              projectTypeIdList: []
            }
          )
        }
      },
      dialogChange (val) {
        this.reset()
        this.item.show = val
        if (val && this.isEdit) {
            this.form.orderId = this.item.data.id
            this.form.contractId = this.item.data.contract.id
            this.form.customerId = this.item.data.customer.id
            this.traNumberInput(this.item.data.contract.productNumber)
        }
      },
      onFileName (fileName, idx) {
        this.form.trademarks[idx].logoFile = `${this.bucket}/${fileName}`
      },
      reset () {
        if (!isEmpty(this.$refs.form)) {
          this.$refs.form.reset()
        }
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.TrademarkTypePid,
              this.$constants.TrademarkAgencyPid
            ]
          }
          ).then(res => {
            if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.TrademarkTypePid === result.id) {
                this_.trademarkTypeItems = result.data
             } else if (this_.$constants.TrademarkAgencyPid === result.id) {
                this_.trademarkAgencyItems = result.data
             }
           })
          }
        })
      }
    },
    created() {
      this.getTypes()
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      },
      projectTypeItems () {
        const projectTypeItems = []
        for (let i = 0; i <= 45; i++) {
          projectTypeItems.push({ text: i, value: i })
        }
        return projectTypeItems
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
